import { render, staticRenderFns } from "./serviceCard.vue?vue&type=template&id=74cb3d18&scoped=true&lang=pug&"
import script from "./serviceCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./serviceCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./serviceCard.vue?vue&type=style&index=0&id=74cb3d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cb3d18",
  null
  
)

export default component.exports